var map = {
	"./QR.png": "b858",
	"./benefit1.png": "8640",
	"./benefit2.png": "447e",
	"./benefit3.png": "074c",
	"./benefit4.png": "c2dc",
	"./benefit5.png": "7355",
	"./benefit6.png": "dd13",
	"./bitcoin.png": "0641",
	"./currency1.png": "e2b2",
	"./currency2.png": "3972",
	"./currency3.png": "7afb",
	"./currency4.png": "bb55",
	"./currency5.png": "bbc8",
	"./currency6.png": "c511",
	"./currency7.png": "f884",
	"./currency8.png": "a8c4",
	"./ethereum.png": "0ab8",
	"./horizontal_logo.png": "a3c0",
	"./koinage_logo.png": "fdc0",
	"./landing.png": "3054",
	"./savvix_logo.png": "c634",
	"./savvix_logo_only.png": "3a5a",
	"./swap_icon.png": "f5be",
	"./top1_icon.svg": "5182"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";